import apiCall from "components/Api/api";
import { todayIST } from "components/Api/common";
import { useAuth } from "provider/AuthContext";
import { useToast } from "provider/ToastProvider";
import React, { useEffect, useRef, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { handleError } from "components/Api/handleError";
import Select from "react-select";
import TextareaAutosize from 'react-textarea-autosize';
import { useMasterContext } from "provider/MasterProvider";
import { useMobileVerifyContext } from "provider/MobileVerificationProvider";
import MobileNoVerificationModal from "./mobilenoverification/MobileNoVerificationModal";

const GetQuoteForm = ({ title, quotationFormNote, reqUrl, quoteRequestFrom, parkDropDown, accomDropDown }) => {

  const { logout, userProfile } = useAuth();
  const { showErrorToast, showSuccessToast } = useToast();
  const navigate = useNavigate();
  const { safariCategory } = useMasterContext();
  const { toggleMobileVerify, mobileVerifyDispatch } = useMobileVerifyContext();
  const textareaRef = useRef(null);
  const maxLength = 1000;
  const [loading, setLoading] = useState(false);
  const [quoteNotes, setQuoteNote] = useState('')
  const [parkSlug, setParkSlug] = useState('');
  const [accomOPtion, setAccomOption] = useState([]);

  const [formData, setFormData] = useState({
    safaris: 1,
    travelers: 1,
    stay_category_id: '',
    start_date: '',
    end_date: '',
    safari_park_id: '',
    user_notes: ''
  })
  const [errors, setErrors] = useState({
    safaris: '',
    travelers: '',
    stay_category_id: '',
    start_date: '',
    end_date: '',
    safari_park_id: '',
    user_notes: ''

  })

  useEffect(() => {
    const fetchParkDetail = async () => {
      try {
        setLoading(true)
        const [
          parkQouteOptionResponse,
        ] = await Promise.allSettled([
          apiCall({ url: `park/${parkSlug}/park-stay-category?pageSize=20`, method: "GET" })
        ])
        if (parkQouteOptionResponse?.status === "fulfilled" && parkQouteOptionResponse?.value?.status === 200) {
          if (parkQouteOptionResponse?.value?.data?.errors) {
            console.error("API returned errors:", parkQouteOptionResponse?.value?.data.errors);
          } else {
            const data = parkQouteOptionResponse?.value?.data?.stay_category_options?.data;
            const options = data.map((item) => ({
              label: item.title,
              value: item.id,
            }));

            setAccomOption(options)
          }

        } else {
          console.error(`Unexpected response status: ${parkQouteOptionResponse?.value?.status}`);

        }
      } catch (error) {
        console.error("Park detail fetch error:", error);

      } finally {
        setLoading(false)
      }
    };

    if (parkSlug) {
      fetchParkDetail();
    }
  }, [parkSlug]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    // Clear error as user corrects the field
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const handleChangeNotes = (e) => {
    const value = e.target.value.slice(0, maxLength);
    const trimmed = value.trim() ? value : '';
    setFormData({
      ...formData,
      user_notes: trimmed
    });
    setErrors({
      ...errors,
      user_notes: ''
    });
  };

  const update = (name, value) => {
    setFormData({
      ...formData,
      [name]: value
    });

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };



  const validate = () => {
    const newErrors = {};

    if (formData.safaris < 1) {
      newErrors.safaris = "At least one safari is required.";
    }

    if (formData.travelers < 1) {
      newErrors.travelers = "At least one traveler is required.";
    }

    if (!formData.stay_category_id) {
      newErrors.stay_category_id = "Please select accommodation.";
    }

    if (!formData.start_date) {
      newErrors.start_date = "Start date is required.";
    } else if (formData.start_date < todayIST) {
      newErrors.start_date = "Start date cannot be in the past.";
    }

    if (!formData.end_date) {
      newErrors.end_date = "End date is required.";
    } else if (formData.end_date <= formData.start_date) {
      newErrors.end_date = "End date must be after start date.";
    }
    if (quoteRequestFrom === 'opProfile' && !formData.safari_park_id) {
      newErrors.safari_park_id = "Please select a safari park.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const submitForm = async () => {
    const isValid = validate();
    if (!isValid) return;
    if (!userProfile?.is_mobile_no_verified) {
      mobileVerifyDispatch({ type: "MOBILE_VERIFY_TOGGLE", payload: true });
      return;
    }
    try {
      setLoading(true);
      const formDataSubmit = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '' && value !== 0) {
          // Only append safari_park_id if quoteRequestFrom is 'opProfile'
          if (key === "safari_park_id" && quoteRequestFrom !== "opProfile") {
            return;
          }
          formDataSubmit.append(key, value);
        }
      });

      const response = await apiCall({
        url: reqUrl,
        method: "POST",
        data: formDataSubmit,
      });
      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
      const apiData = response.data;

      if (apiData?.status === 1) {
        showSuccessToast(apiData?.message);
        setFormData({
          safaris: 1,
          travelers: 1,
          stay_category_id: '',
          start_date: '',
          end_date: '',
          safari_park_id: '',
          user_notes: ''
        })
        setErrors({
          safaris: '',
          travelers: '',
          stay_category_id: '',
          start_date: '',
          end_date: '',
          safari_park_id: '',
          user_notes: ''
        })
      } else {
        showErrorToast(apiData?.message)
        console.error("error:", apiData?.message)
      }

    } catch (error) {
      console.error(error);
      handleError(error, logout, navigate);
    } finally {
      setLoading(false)
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    submitForm();
  };

  return (
    <>
      <div className="mb-4 position-relative" id="memberview">
        <div className="getquote_box">
          <div className="get_free_title2 text-center pb-3">
            <h4>{title}</h4>
          </div>

          <Form onSubmit={handleSubmit}>
            <Row className="gx-2">
              <Col xs={12}>
                <Row>
                  {quoteRequestFrom === 'opProfile' && <Col md={12}>
                    <div className="form-wrapper">
                      <Form.Group className="input-group2">
                        <Form.Label className="p-0 m-0">Safari Park</Form.Label>
                        <Select
                          value={parkDropDown?.find((p) => p.value === formData?.safari_park_id) || null}
                          onChange={(selectedOption) => {
                            setFormData({
                              ...formData,
                              safari_park_id: selectedOption?.value || 0
                            })
                            setQuoteNote(selectedOption?.quotation_form_note);
                            setParkSlug(selectedOption?.slug)
                          }


                          }
                          options={parkDropDown}
                          isSearchable
                          isClearable
                          placeholder="Select Park"
                          components={{ IndicatorSeparator: () => null }}
                          className="mb-3"
                        />
                        {errors?.safari_park_id && (
                          <div className="invalid-feedback d-block">{errors.safari_park_id}</div>
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                  }
                  {/* Safaris */}
                  <Col sm={6} xs={12}>
                    <div className="form-wrapper">
                      <Form.Group className="input-group2">
                        <Form.Label className="p-0 m-0">Safaris</Form.Label>
                        <div className="number-input position-relative">
                          <Form.Control
                            type="text"
                            value={formData?.safaris}
                            name='safaris'
                            readOnly
                            className="mb-3 field-safaris required"
                          />
                          <div className="bton_updown">
                            <button
                              type="button"
                              // onClick={() => setSafaris(safaris + 1)}
                              onClick={() => {
                                setFormData({
                                  ...formData,
                                  safaris: formData?.safaris + 1
                                })
                              }}
                            >
                              <i className="fa-solid fa-chevron-up"></i>
                            </button>
                            <button
                              type="button"
                              // onClick={() =>
                              //   setSafaris((prev) => Math.max(prev - 1, 0))
                              // }
                              onClick={() =>
                                setFormData((prev) => ({
                                  ...prev,
                                  safaris: Math.max(prev.safaris - 1, 1)
                                }))
                              }
                            >
                              <i className="fa-solid fa-chevron-down"></i>
                            </button>
                          </div>
                          {errors?.safaris && (
                            <div className="invalid-feedback d-block">{errors.safaris}</div>
                          )}
                        </div>
                      </Form.Group>
                    </div>
                  </Col>

                  {/* Travelers */}
                  <Col sm={6} xs={12}>
                    <div className="form-wrapper">
                      <Form.Group className="input-group2">
                        <Form.Label className="p-0 m-0">Travelers</Form.Label>
                        <div className="number-input position-relative">
                          <Form.Control
                            type="text"
                            value={formData?.travelers}
                            readOnly
                          />
                          <div className="bton_updown">
                            <button
                              type="button"
                              onClick={() => {
                                setFormData({
                                  ...formData,
                                  travelers: formData?.travelers + 1
                                })
                              }}
                            >
                              <i className="fa-solid fa-chevron-up"></i>
                            </button>
                            <button
                              type="button"
                              onClick={() =>
                                setFormData((prev) => ({
                                  ...prev,
                                  travelers: Math.max(prev.travelers - 1, 1)
                                }))
                              }
                            >
                              <i className="fa-solid fa-chevron-down"></i>
                            </button>
                          </div>
                          {errors?.travelers && (
                            <div className="invalid-feedback d-block">{errors.travelers}</div>
                          )}
                        </div>
                      </Form.Group>
                    </div>
                  </Col>
                </Row>
              </Col>

              {/* Accommodation */}
              {quoteRequestFrom === 'opProfile' && <Col lg={12}>
                <div className="form-wrapper">
                  <Form.Group controlId="formAccommodation">
                    <Form.Label className="p-0 m-0">Accommodation</Form.Label>
                    <Form.Select
                      className="mb-1"
                      name="stay_category_id"
                      onChange={handleChange}
                      value={formData?.stay_category_id}
                      disabled={loading}
                    >
                      <option
                        value=""
                        className="select2-selection__placeholder"
                        style={{ fontSize: "14px", color: "#9999" }}
                      >
                        Select...
                      </option>
                      {accomOPtion?.map((item, index) => (
                        <option value={item?.value} key={index}>
                          {item?.label}
                        </option>
                      ))}
                    </Form.Select>
                    {errors?.stay_category_id && (
                      <div className="invalid-feedback d-block">{errors.stay_category_id}</div>
                    )}
                  </Form.Group>
                </div>
              </Col>
              }
              {quoteRequestFrom === 'parkView' && <Col lg={12}>
                <div className="form-wrapper">
                  <Form.Group controlId="formAccommodation">
                    <Form.Label className="p-0 m-0">Accommodation</Form.Label>
                    <Form.Select
                      className="mb-1"
                      name="stay_category_id"
                      onChange={handleChange}
                      value={formData?.stay_category_id}
                    >
                      <option
                        value=""
                        className="select2-selection__placeholder"
                        style={{ fontSize: "14px", color: "#9999" }}
                      >
                        Select...
                      </option>
                      {accomDropDown?.map((item, index) => (
                        <option value={item?.value} key={index}>
                          {item?.label}
                        </option>
                      ))}
                    </Form.Select>
                    {errors?.stay_category_id && (
                      <div className="invalid-feedback d-block">{errors.stay_category_id}</div>
                    )}
                  </Form.Group>
                </div>
              </Col>
              }

              {/* Start Date */}
              <Col sm={6} xs={12}>
                <div className="form-wrapper">
                  <Form.Group controlId="formStartDate">
                    <Form.Label className="p-0 m-0" >Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="start_date"
                      value={formData?.start_date}
                      isInvalid={
                        !!errors?.start_date ||
                        (formData?.start_date && formData?.start_date < todayIST)
                      }
                      min={todayIST}
                      onChange={(e) => update("start_date", e.target.value)}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    {errors?.start_date && (
                      <div className="invalid-feedback d-block">{errors.start_date}</div>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* End Date */}
              <Col sm={6} xs={12}>
                <div className="form-wrapper">
                  <Form.Group controlId="formEndDate">
                    <Form.Label className="p-0 m-0">End Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="end_date"
                      value={formData?.end_date}
                      min={todayIST}
                      onChange={(e) => update("end_date", e.target.value)}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    {errors?.end_date && (
                      <div className="invalid-feedback d-block">{errors.end_date}</div>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col md={12} sm={12} xs={12}>
                <div className="form-wrapper mt-3">
                  <Form.Label className="m-0 p-0">Additional Notes</Form.Label>
                  <TextareaAutosize
                    ref={textareaRef}
                    name="Chat[user_notes]"
                    placeholder="Type a Message"
                    className="form-control  hide-scrollbar text-area-commet"
                    value={formData?.user_notes}
                    onChange={handleChangeNotes}
                    maxLength={maxLength}
                    minRows={3}
                    maxRows={10}
                  />
                  {quotationFormNote && <p className="m-0 addi-note"><span className="fw-bold">Notes:</span> {quotationFormNote}</p>}
                  {quoteNotes && <p className="m-0  addi-note"><span className="fw-bold">Notes:</span> {quoteNotes}</p>}
                </div>
              </Col>

              {/* Submit Button */}
              <Col lg={12} className="pt-lg-0 content-center">
                <button type="submit" className="sent_btn w-100 mb-3 mt-3" disabled={loading}>
                  Send Request
                </button>
              </Col>

              {/* Info Text */}
              <Col lg={12}>
                <div className="text_get">
                  <p>
                    <span className="text-danger">*</span> We’ll share your request with all operators in
                    the park and send you their quotes.
                  </p>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>

      {toggleMobileVerify && <MobileNoVerificationModal handleSubmit={submitForm} title="You need to verify your phone number" />}
    </>
  );
};

export default GetQuoteForm;
